<template>
  <PopularDecks :tag="$route.params.tag" />
</template>
<script>
import PopularDecks from '~/components/PopularDecks'

export default {
  components: {
    PopularDecks
  }
}
</script>
